import React, { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { Button, Icon } from 'gu-ui-kit'
import { useDispatch } from 'react-redux'
import { notificationShow } from 'modules/Notifications/actions'
import { useTranslation } from 'react-i18next'

export const RefundButton = ({ title, extra_info, ...rest }) => {
  const dispatch = useDispatch()
  const breakpoint = useBreakpoint()
  const { t } = useTranslation()

  const hasPendingRefunds = useMemo(
    () => Array.isArray(extra_info) && extra_info.includes('has_pending_refunds'),
    [extra_info],
  )

  const handleClick = useCallback(() => {
    if (!hasPendingRefunds) {
      return
    }

    dispatch(
      notificationShow({
        type: 'error',
        message: t('services::account.notifications.has_pending_refunds.error'),
      }),
    )
  }, [hasPendingRefunds])

  return (
    <Button
      component={hasPendingRefunds ? 'button' : Link}
      onClick={handleClick}
      {...rest}
      endIcon={
        !breakpoint.lg && hasPendingRefunds ? (
          <Icon
            name={'timer'}
            color={'Interface-Orange-Primary'}
          />
        ) : null
      }
      additionalIcon={
        breakpoint.lg && hasPendingRefunds ? (
          <Icon
            name={'status timer'}
            size={breakpoint.lg ? 'sm' : 'm'}
            style={{
              top: '-7px',
              right: '-7px',
            }}
          />
        ) : null
      }
    >
      {title}
    </Button>
  )
}

RefundButton.propTypes = {
  title: PropTypes.string,
  startIcon: PropTypes.element,
  icon: PropTypes.string,
  extra_info: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.oneOf([undefined])]),
  ]),
}
